var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"prize"},[_c('h2',[_vm._v(_vm._s(_vm.prize.name))]),_c('img',{attrs:{"src":_vm.prize.imageUrl,"alt":_vm.prize.name,"title":_vm.prize.name}})])}
var staticRenderFns = []

export { render, staticRenderFns }